/* Ford: replace the two existing card sources; retain all media nodes/order. */
(function () {
  'use strict';

  var PRODUCT_ID = '10413872709966';
  var SLOTS = { switch: '54085215420750', controls: '54085602738510' };
  var theme = window.T4SThemeSP;
  var jq = window.jQuery_T4NT;
  if (!theme || !theme.Carousel || !theme.Carousel.prototype ||
      typeof theme.Carousel.prototype.thumbnailsMarkup !== 'function' || typeof jq !== 'function') return;

  function json(text) { try { return JSON.parse(text); } catch (_) { return null; } }
  var root = Array.from(document.querySelectorAll('[data-product-featured]')).find(function (node) {
    var data = json(node.getAttribute('data-product-featured'));
    return data && String(data.id) === PRODUCT_ID && data.isMainProduct === true;
  });
  if (!root || root.__coFordGalleryCards) return;
  var metadata = json(root.getAttribute('data-product-featured'));
  var configNode = root.querySelector('[data-co-ford-gallery-cards]');
  var config = configNode && json(configNode.textContent);
  var gallery = root.querySelector('[data-main-media][data-t4s-gallery]');
  var form = metadata.formID && root.querySelector(metadata.formID);
  if (!config || String(config.productId) !== PRODUCT_ID || !config.variants || !gallery || !form) return;

  function selectedVariant() {
    var selector = form.querySelector('[name="id"]');
    return selector ? String(selector.value) : '';
  }
  function asset(value) {
    if (!value || typeof value.src !== 'string' || typeof value.alt !== 'string' ||
        !Number.isInteger(value.width) || value.width < 1 || !Number.isInteger(value.height) || value.height < 1) return null;
    try {
      var url = new URL(value.src, 'https://www.caroptions.nl');
      if (url.protocol !== 'https:' || !['cdn.shopify.com', 'www.caroptions.nl', 'caroptions.nl'].includes(url.hostname) ||
          !url.pathname.includes('/files/') || !url.searchParams.has('v')) return null;
      return { src: url.href, width: value.width, height: value.height, alt: value.alt };
    } catch (_) { return null; }
  }
  var originals = {};
  Object.keys(SLOTS).forEach(function (key) {
    var node = gallery.querySelector('[data-media-id="' + SLOTS[key] + '"]');
    var img = node && node.querySelector('img[data-master]');
    if (img) originals[key] = asset({ src: img.getAttribute('data-master'), width: Number(img.getAttribute('width')),
      height: Number(img.getAttribute('height')), alt: img.getAttribute('alt') || '' });
  });
  if (!originals.switch || !originals.controls) return;

  var activeVariant = selectedVariant();
  var latestCarousel = gallery.flickityt4s || null;
  function pair() {
    var entry = config.variants[activeVariant];
    var first = entry && asset(entry.switch);
    var second = entry && asset(entry.controls);
    // An unknown/incomplete variant must never inherit the preceding model's cards.
    return first && second ? { switch: first, controls: second } : originals;
  }
  function widthUrl(src, width) {
    var url = new URL(src);
    url.searchParams.set('width', String(width));
    return url.href;
  }
  function replaceNode(node, image, thumbnail) {
    if (!node) return;
    Array.from(node.querySelectorAll('img')).forEach(function (img) {
      if (img.getAttribute('data-master') === image.src && img.getAttribute('data-co-ford-card-source') === image.src) return;
      var resolved = widthUrl(image.src, Math.min(image.width, thumbnail ? 360 : 1600));
      img.setAttribute('data-master', image.src);
      img.setAttribute('data-src', resolved);
      // Drop a previously loaded responsive candidate before setting the new source.
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      // These two changing images load directly, outside the original lazy sizing queue.
      img.removeAttribute('data-sizes');
      img.classList.remove('lazyloadt4s', 'lazyloadt4sing', 'lazyautosizes');
      img.classList.add('lazyloadt4sed');
      img.setAttribute('src', resolved);
      img.setAttribute('width', image.width);
      img.setAttribute('height', image.height);
      img.setAttribute('alt', image.alt);
      img.setAttribute('data-co-ford-card-source', image.src);
    });
    Array.from(node.querySelectorAll('.t4s_ratio')).forEach(function (ratio) {
      ratio.style.setProperty('--aspect-ratioapt', String(image.width / image.height));
      ratio.style.setProperty('--mw-media', image.width + 'px');
      if (thumbnail) ratio.style.backgroundImage = 'url("' + widthUrl(image.src, 360) + '")';
    });
  }
  function replaceSlots(container, images, thumbnail) {
    if (!container) return;
    Object.keys(SLOTS).forEach(function (key) {
      Array.from(container.querySelectorAll('[data-media-id="' + SLOTS[key] + '"]')).forEach(function (node) {
        replaceNode(node, images[key], thumbnail);
      });
    });
  }
  function patchSources() {
    var images = pair();
    replaceSlots(gallery, images, false);
    // StarApps clones these two offscreen caches on each different hero group.
    replaceSlots(document.querySelector('#multi-variant-info'), images, false);
    replaceSlots(document.querySelector('#multi-variant-thumb'), images, true);
    return images;
  }
  function patchLiveThumbs(images) {
    var nav = latestCarousel && latestCarousel.$carouselNav && latestCarousel.$carouselNav[0];
    if (!nav) nav = root.querySelector('.t4s-carousel__nav');
    if (!nav) return;
    var slides = Array.from(gallery.querySelectorAll('[data-main-slide]'));
    var thumbs = Array.from(nav.querySelectorAll('.t4s-carousel__nav-item'));
    // Native thumbnails have no media ID; their index equals the native slide index.
    if (slides.length !== thumbs.length) return;
    slides.forEach(function (slide, index) {
      Object.keys(SLOTS).forEach(function (key) {
        if (slide.getAttribute('data-media-id') === SLOTS[key]) replaceNode(thumbs[index], images[key], true);
      });
    });
  }

  var nativeThumbnails = theme.Carousel.prototype.thumbnailsMarkup;
  theme.Carousel.prototype.thumbnailsMarkup = function () {
    if (this.el === gallery) {
      latestCarousel = this;
      // Kalles calls this before constructing Flickity; StarApps also calls it on rebuild.
      patchSources();
    }
    var result = nativeThumbnails.apply(this, arguments);
    if (this.el === gallery) patchLiveThumbs(pair());
    return result;
  };
  root.__coFordGalleryCards = true;
  jq(root).on('variant:changed.coFordGalleryCards', function (event) {
    activeVariant = event.currentVariant ? String(event.currentVariant.id) : selectedVariant();
    patchLiveThumbs(patchSources());
  });
  patchLiveThumbs(patchSources());
}());
